<template>
    <div class="form-group">
        <label :for="getFieldId" v-if="!withPlaceholder" v-text="placeholder"></label>
        <textarea class="form-control"
                  type="text"
                  :value="value"
                  :name="name"
                  :id="getFieldId"
                  :required="required"
                  :placeholder="printPlaceholder"
                  :autocomplete="autocomplete"
                  :maxlength="maxlength"
                  @input="updateValue($event.target.value)"
                  ref="input"></textarea>
        <div v-if="displayRemainingCharacters" class="display-remaining-characters" v-text="`${this.value.length} characters of ${this.maxlength} allowed.`"></div>
    </div>
</template>
<script>

    let Input = require('@/mixins/InputField')

    export default {

        mixins: [Input],

        props: {

            displayRemainingCharacters: {
                required: false,
                default: false,
            }
        }
    }
 </script>
